import * as React from 'react';

import Glyph from 'components/Glyph';
import Link from 'components/Link';
import MediaObject from 'components/MediaObject';
import Text from 'components/Text';

import './styles/WizardSteps.scss';

export type WizardStepNode = {
  name: string;
  complete: boolean;
  active: boolean;
  nodeKey: string;
};

type Props = {
  nodes: WizardStepNode[];
  onClickNode: (nodeKey: string) => void;
};

export default function WizardSteps(props: Props) {
  const { nodes } = props;

  return (
    <ul className="WizardSteps">
      {nodes.map(node => {
        let status;

        if (node.complete) {
          status = 'complete';
        } else if (node.active) {
          status = 'active';
        } else {
          status = 'incomplete';
        }

        return (
          <li key={node.name} className={`WizardSteps-node WizardSteps-node--${status}`}>
            <Link onClick={() => props.onClickNode(node.nodeKey)}>
              <MediaObject center>
                <span className={`WizardSteps-node-dot WizardSteps-node-dot--${status}`}>
                  {status === 'complete' ? (
                    <Glyph name="check" color="white" size="xxsmall" solo />
                  ) : null}
                </span>
                <Text color="pitch" weight={status === 'active' ? 'semibold' : 'normal'}>
                  {node.name}
                </Text>
              </MediaObject>
            </Link>
          </li>
        );
      })}
    </ul>
  );
}
